import type { Delegation } from '../../api/types';

/** Horizon d'alerte des délégations arrivant à expiration (jours). */
export const HORIZON_EXPIRATION_JOURS = 15;

/** Délégations en vigueur qui expirent dans l'horizon donné (tableau de bord du SG, H7-06). */
export function delegationsArrivantAExpiration(delegations: Delegation[], maintenant = new Date(), jours = HORIZON_EXPIRATION_JOURS): Delegation[] {
  const limite = maintenant.getTime() + jours * 24 * 3600 * 1000;
  return delegations
    .filter((d) => d.statut === 'en_vigueur' && new Date(d.fin).getTime() <= limite)
    .sort((a, b) => a.fin.localeCompare(b.fin));
}
